<template>
    <div>
        <nav aria-label="items-project">
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-general-tab" data-toggle="tab" href="#nav-general" role="tab"
                    aria-controls="nav-general" aria-selected="true">Datos Generales</a>
                <a class="nav-item nav-link" id="nav-questions-tab" data-toggle="tab" href="#nav-questions" role="tab"
                    aria-controls="nav-questions" aria-selected="false">Preguntas</a>
                <a class="nav-item nav-link" id="nav-team-tab" data-toggle="tab" href="#nav-team" role="tab"
                    aria-controls="nav-team" aria-selected="false">Equipo</a>
                <a class="nav-item nav-link" id="nav-logs-tab" data-toggle="tab" href="#nav-logs" role="tab"
                    aria-controls="nav-logs" aria-selected="false">Log de cambios</a>
            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent" v-if="!isContest2024()">
            <div class="tab-pane fade show active" id="nav-general" role="tabpanel" aria-labelledby="nav-general-tab">
                <div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">ID</label>
                                <input type="text" class="form-control" :value="model.id ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">ID Post Asignado en Comunidad</label>
                                <input type="text" class="form-control" :value="model.community_post_id ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Estado</label>
                                <input type="text" class="form-control" :value="model.is_completed &&
                                    model.is_full_information
                                    ? 'Completo'
                                    : 'Incompleto'
                                    " readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="concurso">Concurso</label>
                                <input type="text" class="form-control" :value="model.contest_name ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Nombre Emprendimiento</label>
                                <input type="text" class="form-control" :value="model.name ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Pais</label>
                                <input type="text" class="form-control" :value="model.origin_country ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Proyecto Migrado a Comunidad</label>
                                <input type="text" class="form-control" :value="model.send_community_confirm ?? '-'"
                                    readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Url Pagina web
                                    <a v-if="model.web_site" :href="model.web_site" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.web_site ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Facebook
                                    <a v-if="model.facebook" :href="model.facebook" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.facebook ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Instagram
                                    <a v-if="model.instagram" :href="model.instagram" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.instagram ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Url Twitter
                                    <a v-if="model.twitter" :href="model.twitter" target="_blank" rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.twitter ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url LinkedIn
                                    <a v-if="model.linkedin" :href="model.linkedin" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.linkedin ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url TikTok
                                    <a v-if="model.tiktok" :href="model.tiktok" target="_blank" rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.tiktok ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Url YouTube
                                    <a v-if="model.youtube" :href="model.youtube" target="_blank" rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.youtube ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Pitch
                                    <a v-if="model.video" :href="model.video" target="_blank" rel="noopener noreferrer">
                                        (Ver video)</a></label>
                                <input type="text" class="form-control" :value="model.video ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Logo Equipo
                                    <a v-if="model.logo_url" :href="model.logo_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver Logo)</a></label>
                                <input type="text" class="form-control" :value="model.logo_url ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Url Imagen Equipo
                                    <a v-if="model.image_url" :href="model.image_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver imagen)</a></label>
                                <input type="text" class="form-control" :value="model.image_url ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Imagen del Producto
                                    <a v-if="model.product_image_url" :href="model.product_image_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver imagen)</a></label>
                                <input type="text" class="form-control" :value="model.product_image_url ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-questions" role="tabpanel" aria-labelledby="nav-questions-tab">
                <div>
                    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2">
                        <span>
                            <div class="form-group col">
                                <label for="">Etapa del emprendimiento</label>
                                <textarea class="form-control" rows="2" :value="model.project_phase ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Categoria</label>
                                <textarea class="form-control" rows="2" :value="model.category_name ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Alcance del emprendimiento</label>
                                <textarea class="form-control" rows="2" :value="handleLevelImplementation(
                                    model.scope_of_business
                                )
                                    " readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Nivel de ventas / ingresos anuales</label>
                                <textarea class="form-control" rows="2" :value="model.annual_sale ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Describe el emprendimiento</label>
                                <textarea class="form-control" rows="5" :value="model.initiative ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Caracteristicas diferenciales</label>
                                <textarea class="form-control" rows="5" :value="model.solve_what ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Problematica que resuelve</label>
                                <textarea class="form-control" rows="5" :value="model.solve_how ?? '-'" readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Momento de revelación</label>
                                <textarea class="form-control" rows="5" :value="model.initiative_explanation ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">El emprendimiento se puede expandir</label>
                                <textarea class="form-control" rows="5" :value="model.expand_explain ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Población que esta impactando</label>
                                <textarea class="form-control" rows="5" :value="model.problem_population ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Áreas del emprendimiento</label>
                                <textarea class="form-control" rows="5" :value="model.areas ?? '-'" readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Porqué quieres ser parte de
                                    Social-Skin</label>
                                <textarea class="form-control" rows="5" :value="model.why_chose_socialskin ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Tipo y cantidad de clientes actuales</label>
                                <textarea class="form-control" rows="5" :value="model.clients_type ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1">
                        <span>
                            <div class="form-group col-lg-8 col col-sm">
                                <label>Información adicional</label>
                                <textarea class="form-control" rows="5" :value="model.adittional_information ?? ''"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-team" role="tabpanel" aria-labelledby="nav-team-tab">
                <div v-for="team in model.team_full" :key="team.id" class="mb-3">
                    <h4>Integrante {{ team.id }}</h4>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Nombres</label>
                                <input type="text" class="form-control" :value="team.name ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Apellidos</label>
                                <input type="text" class="form-control" :value="team.lastname ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Pais</label>
                                <input type="text" class="form-control" :value="team.residence_country_name ?? '-'"
                                    readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Ciudad</label>
                                <input type="text" class="form-control" :value="team.residence_city ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Email</label>
                                <input type="text" class="form-control" :value="team.email ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Teléfono</label>
                                <input type="text" class="form-control" :value="team.phone_number_format ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Fecha Nacimiento</label>
                                <input type="text" class="form-control" :value="team.birth_date ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Identificación</label>
                                <input type="text" class="form-control" :value="team.document_number ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Rol</label>
                                <input type="text" class="form-control" :value="team.rol ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Evidencia Documento
                                    <a v-if="team.document_evidence" :href="team.document_evidence_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="team.document_evidence_url ?? '-'"
                                    readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Evidencia Autorización
                                    <a v-if="team.document_evidence" :href="team.document_evidence_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="team.document_evidence_url ?? '-'"
                                    readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Edad</label>
                                <input type="text" class="form-control" :value="team.age ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-logs" role="tabpanel" aria-labelledby="nav-logs-tab">
                <div>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Opciones</th>
                                <th scope="col">Nombre Responsable</th>
                                <th scope="col">Correo Responsable</th>
                                <th scope="col">Concurso</th>
                                <th scope="col">Fecha</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="change in changes" :key="change.id">
                                <td>
                                    <button type="button" @click="show_change(change)" class="btn btn-warning btn-sm"
                                        data-toggle="modal" data-target="#exampleModal">
                                        <em class="fa fa-eye"></em>
                                    </button>
                                </td>
                                <td v-text="change.user.name"></td>
                                <td v-text="change.user.email"></td>
                                <td v-text="change.contest.name"></td>
                                <td v-text="change.created_at"></td>
                            </tr>
                        </tbody>
                    </table>
                    <nav aria-label="log-paginator">
                        <ul class="pagination">
                            <li class="page-item" v-if="pagination.current_page > 1">
                                <a class="page-link" href="#" @click="
                                    changePage(pagination.current_page - 1)
                                    ">Ant</a>
                            </li>
                            <li class="page-item" v-for="page in pagesNumber" :key="page"
                                :class="[page == isActived ? 'active' : '']">
                                <a class="page-link" href="#" @click="changePage(page)" v-text="page"></a>
                            </li>
                            <li class="page-item" v-if="pagination.current_page <
                                pagination.last_page
                                ">
                                <a class="page-link" href="#" @click="
                                    changePage(pagination.current_page + 1)
                                    ">Sig</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-body">
                                <div class="d-flex justify-content-around mt-2">
                                    <div class="m-3" style="
                                            width: 800px;
                                            padding: 5px;
                                            white-space: nowrap;
                                            overflow-x: auto;
                                        ">
                                        <div>
                                            <h5>Valor inicial</h5>
                                            <vue-json-pretty :path="'res'" :data="initial_value">
                                            </vue-json-pretty>
                                        </div>
                                    </div>
                                    <div class="m-3" style="
                                            width: 800px;
                                            padding: 5px;
                                            white-space: nowrap;
                                            overflow-x: auto;
                                        ">
                                        <div>
                                            <h5>Valor actual</h5>
                                            <vue-json-pretty v-if="actual_value" :path="'res'" :data="actual_value">
                                            </vue-json-pretty>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tab-content" id="nav-tabContent" v-if="isContest2024()">
            <div class="tab-pane fade show active" id="nav-general" role="tabpanel" aria-labelledby="nav-general-tab">
                <div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">ID</label>
                                <input type="text" class="form-control" :value="model.id ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">ID Post Asignado en Comunidad</label>
                                <input type="text" class="form-control" :value="model.community_post_id ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Estado</label>
                                <input type="text" class="form-control" :value="model.is_completed &&
                                    model.is_full_information
                                    ? 'Completo'
                                    : 'Incompleto'
                                    " readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="concurso">Concurso</label>
                                <input type="text" class="form-control" :value="model.contest_name ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Nombre Emprendimiento</label>
                                <input type="text" class="form-control" :value="model.name ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Pais</label>
                                <input type="text" class="form-control" :value="model.origin_country ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Proyecto Migrado a Comunidad</label>
                                <input type="text" class="form-control" :value="model.send_community_confirm ?? '-'"
                                    readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Url Pagina web
                                    <a v-if="model.web_site" :href="model.web_site" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.web_site ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Facebook
                                    <a v-if="model.facebook" :href="model.facebook" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.facebook ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Instagram
                                    <a v-if="model.instagram" :href="model.instagram" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.instagram ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Url Twitter
                                    <a v-if="model.twitter" :href="model.twitter" target="_blank" rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.twitter ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url LinkedIn
                                    <a v-if="model.linkedin" :href="model.linkedin" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.linkedin ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Google Play
                                    <a v-if="model.google_play" :href="model.google_play" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.google_play ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Url App Store
                                    <a v-if="model.app_store" :href="model.app_store" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.app_store ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url YouTube
                                    <a v-if="model.youtube" :href="model.youtube" target="_blank" rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.youtube ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Pitch Deck
                                    <a v-if="model.file_url" :href="model.file_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.file_url ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-md-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Url Video
                                    <a v-if="model.video" :href="model.video" target="_blank" rel="noopener noreferrer">
                                        (Ver video)</a></label>
                                <input type="text" class="form-control" :value="model.video ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Logo Equipo
                                    <a v-if="model.logo_url" :href="model.logo_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.logo_url ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Imagen Equipo
                                    <a v-if="model.image_url" :href="model.image_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.image_url ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Url Imagen del Producto
                                    <a v-if="model.product_image_url" :href="model.product_image_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="model.product_image_url ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-questions" role="tabpanel" aria-labelledby="nav-questions-tab">
                <div>
                    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2">
                        <span>
                            <div class="form-group col">
                                <label for="">Etapa del emprendimiento</label>
                                <textarea class="form-control" rows="2" :value="model.project_phase ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Categoria</label>
                                <textarea class="form-control" rows="2" :value="model.category_name ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Alcance del emprendimiento</label>
                                <textarea class="form-control" rows="2" :value="handleLevelImplementation(
                                    model.scope_of_business
                                )
                                    " readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Nivel de ventas / ingresos anuales</label>
                                <textarea class="form-control" rows="2" :value="model.annual_sale ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Rango edad</label>
                                <textarea class="form-control" rows="2" :value="model.age_range ?? '-'" readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Proceso patente</label>
                                <textarea class="form-control" rows="2"
                                    :value="model.apply_patent_process === 1 ? 'Si' : 'No'" readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Número de Radicado de Patente</label>
                                <textarea class="form-control" rows="5" :value="model.patent_filing_number ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Describe el emprendimiento</label>
                                <textarea class="form-control" rows="5" :value="model.initiative ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Problematica que resuelve</label>
                                <textarea class="form-control" rows="5" :value="model.solve_what ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Población que esta impactando</label>
                                <textarea class="form-control" rows="5" :value="model.problem_population ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Monetización emprendimiento</label>
                                <textarea class="form-control" rows="5" :value="model.which_source_income ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Número de personas en el emprendimiento</label>
                                <textarea class="form-control" rows="5" :value="model.number_people ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">¿Cuántas personas fundaron el emprendimiento?</label>
                                <textarea class="form-control" rows="5" :value="model.fundation_number_people ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Explicación diferenciales</label>
                                <textarea class="form-control" rows="5" :value="model.differentiator ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Modelo de negocio integrado al impacto</label>
                                <textarea class="form-control" rows="5" :value="model.impact_integrated_business_model ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Evidencia de que el producto funciona</label>
                                <textarea class="form-control" rows="5" :value="model.evidence_product_works ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Emprendimiento en otros paises</label>
                                <textarea class="form-control" rows="5" :value="setOtherCountriesText()"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Selección diferenciales</label>
                                <textarea class="form-control" rows="5" :value="setDifferentiatorsChecksText()"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Tipo y cantidad de clientes actuales</label>
                                <textarea class="form-control" rows="5" :value="setClientsText()" readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Desarrollo propio para resolver problematica</label>
                                <textarea class="form-control" rows="5"
                                    :value="model['prototype'] ? `Si; ${model['prototype']}` : 'No'" readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Emprendimiento registrado</label>
                                <textarea class="form-control" rows="5" :value="model.chamber_commerce ? 'Si' : 'No'"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Evidencia de registro</label>
                                <textarea class="form-control" rows="5" :value="model.chamber_commerce ?? '-'"
                                    readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Reconocimientos del emprendimiento</label>
                                <textarea class="form-control" rows="5" :value="setRecognitionText()" readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Tipo de Inversión</label>
                                <textarea class="form-control" rows="5" :value="setInvestmentText()" readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">¿De Donde Viene la Inversión?</label>
                                <textarea class="form-control" rows="5" :value="setInvestmentText()" readonly></textarea>
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Principales competidores</label>
                                <textarea class="form-control" rows="5" :value="setCompetitorsText()" readonly></textarea>
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1">
                        <span>
                            <div class="form-group col-lg-8 col col-sm">
                                <label>Información adicional</label>
                                <textarea class="form-control" rows="5" :value="model.adittional_information ?? ''"
                                    readonly></textarea>
                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-team" role="tabpanel" aria-labelledby="nav-team-tab">
                <div v-for="team in model.team_full" :key="team.id" class="mb-3">
                    <h4>Integrante {{ team.id }}</h4>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Nombres</label>
                                <input type="text" class="form-control" :value="team.name ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Apellidos</label>
                                <input type="text" class="form-control" :value="team.lastname ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Pais</label>
                                <input type="text" class="form-control" :value="team.residence_country_name ?? '-'"
                                    readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Ciudad</label>
                                <input type="text" class="form-control" :value="team.residence_city ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Email</label>
                                <input type="text" class="form-control" :value="team.email ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Teléfono</label>
                                <input type="text" class="form-control" :value="team.phone_number_format ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Fecha Nacimiento</label>
                                <input type="text" class="form-control" :value="team.birth_date ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Identificación</label>
                                <input type="text" class="form-control" :value="team.document_number ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Rol</label>
                                <input type="text" class="form-control" :value="team.rol ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Evidencia Documento
                                    <a v-if="team.document_evidence" :href="team.document_evidence_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="team.document_evidence_url ?? '-'"
                                    readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Evidencia Autorización
                                    <a v-if="team.document_evidence" :href="team.document_evidence_url" target="_blank"
                                        rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="team.document_evidence_url ?? '-'"
                                    readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Edad</label>
                                <input type="text" class="form-control" :value="team.age ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Nivel educativo actual</label>
                                <input type="text" class="form-control" :value="team.education_level_name ?? '-'"
                                    readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Institución último estudio</label>
                                <input type="text" class="form-control" :value="team.other_university ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Área o carrera</label>
                                <input type="text" class="form-control" :value="team.study_what ?? '-'" readonly />
                            </div>
                        </span>
                    </div>
                    <div class="row row-cols-1 row-cols-sm-1 row-cols-lg-3">
                        <span>
                            <div class="form-group col">
                                <label for="">Link de Linkedin
                                    <a v-if="team.linkedin" :href="team.linkedin" target="_blank" rel="noopener noreferrer">
                                        (Ver)</a></label>
                                <input type="text" class="form-control" :value="team.linkedin ?? '-'" readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">Tiempo de dedicación al emprendimiento</label>
                                <input type="text" class="form-control" :value="team.dedication_time_quantity ?? '-'"
                                    readonly />
                            </div>
                        </span>
                        <span>
                            <div class="form-group col">
                                <label for="">¿Qué papel jugaste en la creación del emprendimiento?</label>
                                <input type="text" class="form-control" :value="getFoundationRoleLabel(team.foundation_role)" readonly />
                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="nav-logs" role="tabpanel" aria-labelledby="nav-logs-tab">
                <div>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Opciones</th>
                                <th scope="col">Nombre Responsable</th>
                                <th scope="col">Correo Responsable</th>
                                <th scope="col">Concurso</th>
                                <th scope="col">Fecha</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="change in changes" :key="change.id">
                                <td>
                                    <button type="button" @click="show_change(change)" class="btn btn-warning btn-sm"
                                        data-toggle="modal" data-target="#exampleModal">
                                        <em class="fa fa-eye"></em>
                                    </button>
                                </td>
                                <td v-text="change.user.name"></td>
                                <td v-text="change.user.email"></td>
                                <td v-text="change.contest.name"></td>
                                <td v-text="change.created_at"></td>
                            </tr>
                        </tbody>
                    </table>
                    <nav aria-label="log-paginator">
                        <ul class="pagination">
                            <li class="page-item" v-if="pagination.current_page > 1">
                                <a class="page-link" href="#" @click="
                                    changePage(pagination.current_page - 1)
                                    ">Ant</a>
                            </li>
                            <li class="page-item" v-for="page in pagesNumber" :key="page"
                                :class="[page == isActived ? 'active' : '']">
                                <a class="page-link" href="#" @click="changePage(page)" v-text="page"></a>
                            </li>
                            <li class="page-item" v-if="pagination.current_page <
                                pagination.last_page
                                ">
                                <a class="page-link" href="#" @click="
                                    changePage(pagination.current_page + 1)
                                    ">Sig</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-body">
                                <div class="d-flex justify-content-around mt-2">
                                    <div class="m-3" style="
                                            width: 800px;
                                            padding: 5px;
                                            white-space: nowrap;
                                            overflow-x: auto;
                                        ">
                                        <div>
                                            <h5>Valor inicial</h5>
                                            <vue-json-pretty :path="'res'" :data="initial_value">
                                            </vue-json-pretty>
                                        </div>
                                    </div>
                                    <div class="m-3" style="
                                            width: 800px;
                                            padding: 5px;
                                            white-space: nowrap;
                                            overflow-x: auto;
                                        ">
                                        <div>
                                            <h5>Valor actual</h5>
                                            <vue-json-pretty v-if="actual_value" :path="'res'" :data="actual_value">
                                            </vue-json-pretty>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
export default {
    components: {
        VueJsonPretty,
    },
    props: {
        model_id: Number,
    },
    data() {
        return {
            changes: [],
            arrayOtherCountries: [],
            initial_value: null,
            actual_value: null,
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
            model: {},
            levelImplementation: [
                { id: 1, name: "Barrio" },
                { id: 2, name: "Ciudad - Pueblo" },
                { id: 3, name: "Dpto" },
                { id: 4, name: "País" },
                { id: 5, name: "Mundo" },
            ],
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        changePage(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getChangesModel(page);
        },
        getModel() {
            let me = this;
            axios
                .get("/api/projects/show/" + me.model_id)
                .then(function (response) {
                    me.model = response.data;
                })
                .catch(function (error) { });
        },
        getChangesModel(page = 1) {
            let me = this;
            axios
                .get(
                    "/api/users/changes/project/" +
                    me.model_id +
                    "?page=" +
                    page
                )
                .then(function (response) {
                    me.changes = response.data.project_changes.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) { });
        },
        show_change(data) {
            let me = this;
            me.initial_value = JSON.parse(data.initial_value);
            me.actual_value = JSON.parse(data.actual_value);
        },

        handleLevelImplementation(id) {
            if (!id) {
                return "-";
            }

            const data = this.levelImplementation.find((level) => {
                return level.id === id;
            });

            return data.name;
        },

        getOtherCountriesList() {
            let me = this;
            axios
                .get("/api/birth-country")
                .then(function (response) {
                    me.arrayOtherCountries = response.data.result;
                })
                .catch(function (error) { });
        },

        isContest2024() {
            const me = this;
            if (me.model.created_at) {
                const date = new Date(me.model.created_at);
                const year = date.getFullYear();
                if (year <= 2023) return false;
            }
            return true;
        },

        setOtherCountriesText() {
            const me = this;
            if (me.model.other_country && me.model.other_country.length !== 0 && me.arrayOtherCountries) {
                let str = '';
                me.arrayOtherCountries.forEach(item => {
                    if (me.model.other_country.includes(item.id)) {
                        str += `${item.name}, `
                    }
                });
                return `Si; ${str.slice(0, -2)}.`;
            } else {
                return 'No.';
            }
        },

        getFoundationRoleLabel(foundationRole) {
            if (foundationRole == null || foundationRole === '') {
                return '-';
            }
            let items = [];
            try {
                items = typeof foundationRole === 'string' ? JSON.parse(foundationRole) : foundationRole;
            } catch {
                return '-';
            }
            if (!Array.isArray(items) || items.length === 0) {
                return '-';
            }
            const selected = items.find((item) => item && item.selected === true);
            return selected && selected.name != null && selected.name !== '' ? selected.name : '-';
        },

        setDifferentiatorsChecksText() {
            const me = this;
            let str = '';

            if (me.model.check_initiative_difference_technology === 1) str += 'Tecnología, ';
            if (me.model.check_initiative_difference_business === 1) str += 'Modelo de negocio, ';
            if (me.model.check_initiative_difference_channels === 1) str += 'Personalización, ';
            if (me.model.check_initiative_difference_adoption === 1) str += 'Innovación, ';
            if (me.model.check_initiative_difference_ecosystem === 1) str += 'Impacto ambiental, ';
            if (me.model.check_initiative_difference_other === 1) str += 'Otro, ';

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },

        setClientsText() {
            const me = this;
            let str = '';

            if (me.model.clients_type && Array.isArray(me.model.clients_type)) {
                me.model.clients_type.forEach(item => {
                    if (item.selected) str += `${item.name}: ${item.label}, `;
                })
            }

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },

        setRecognitionText() {
            const me = this;
            let str = '';

            if (me.model.recognition) {
                me.model.recognition.forEach(item => {
                    str += `${item.name}: "${item.link}", `;
                })
            }

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },

        setInvestmentText() {
            const me = this;
            let str = '';

            if (me.model.investment) {
                me.model.investment.forEach(item => {
                    if (item.selected) str += `${item.name}, `;
                })
            }

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },

        setCompetitorsText() {
            const me = this;
            let str = '';

            if (me.model.competitors) {
                me.model.competitors.forEach(item => {
                    str += `${item.name}: "${item.link}", `;
                })
            }

            if (str.length > 0) return `Si; ${str.slice(0, -2)}.`;
            else return 'No.';
        },
    },
    mounted() {
        let me = this;
        me.getModel();
        me.getChangesModel();
        me.getOtherCountriesList();
    },
};
</script>
<style scoped>
textarea {
    resize: none;
}

.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}

.celda {
    height: auto;
    width: 600px;
}
</style>
